import { inject, Injectable } from '@angular/core';
import {
  Observable,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { RequestVerificationCodeType } from '../../models/requestVerificationCodeType';
import { DataTableModuleConfiguration } from '../../data-table/datatable-module.config';

@Injectable({ providedIn: 'root' })
export class RequestVerificationService {
  private get apiEndpoint(): string {
    return '/api/v1/request-verification';
  }

  private http = inject(HttpClient);
  private configuration = inject(DataTableModuleConfiguration);

  constructor() {
    if (!this.configuration.apiUrls.workflow) {
      throw new Error('No workflow API URL configured');
    }
  }

  initiateRequestVerification(type: RequestVerificationCodeType): Observable<void> {
    return this.http.post<void>(
      `${this.configuration.apiUrls.workflow! + this.apiEndpoint}/initiate`,
      {},
      { params: { type } },
    );
  }

  initiateAnonymousRequestVerification(email: string, type: RequestVerificationCodeType): Observable<void> {
    return this.http.post<void>(
      `${this.configuration.apiUrls.workflow! + this.apiEndpoint}/anonymous/initiate`,
      {},
      { params: { email, type } },
    );
  }

  validate(type: RequestVerificationCodeType, code: string): Observable<void> {
    return this.http.post<void>(
      `${this.configuration.apiUrls.workflow! + this.apiEndpoint}/verify`,
      { },
      { params: { type, code } },
    );
  }
}
